import React, { Component } from 'react'
import axios from 'axios'
import moment from 'moment'
import CurrencyFormat from 'react-currency-format'
import DateFnsUtils from '@date-io/date-fns'

import { serverUrl, headerRequest } from '../../lib/funApp/general'

import { Card, Col, Container, Row } from 'react-bootstrap'
import { Button, Icon, Table } from 'semantic-ui-react'
import { MDBIcon } from 'mdbreact'
import { FormControl, Grid, InputLabel, MenuItem, Select } from '@material-ui/core'
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers'

export default class ReportsPeriod extends Component {
  constructor() {
    super()
    this.state = {
      dateIni: moment().startOf('month').toDate(),
      dateEnd: moment().endOf('month').toDate(),
      typeFilter: 'R',
      dataRecords: [],
      dataCategory: [],
      isLoading: false,
      isDisabled: false,
      total: 0,
    }
  }

  componentDidMount() {
    this.getCategories()
    this.getRecords()
  }

  changeDateIni = (value) => {
    this.setState({ dateIni: value })
  }

  changeDateEnd = (value) => {
    this.setState({ dateEnd: value })
  }

  changeTypeFilter = (value) => {
    this.setState({ typeFilter: value })
  }

  getCategories = () => {
    axios
      .get(serverUrl + '/src/categories', { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        this.setState({ dataCategory: items })
      })
      .catch((error) => {
        console.log(error.response || error)
      })
  }

  getRecords = () => {
    this.setState({ isLoading: true, isDisabled: true })

    const targetUrl =
      serverUrl +
      '/src/records?dtstart=' +
      moment(this.state.dateIni).format('YYYY-MM-DD') +
      '&dtend=' +
      moment(this.state.dateEnd).format('YYYY-MM-DD') +
      '&prevision=exclude'

    axios
      .get(targetUrl, { headers: headerRequest })
      .then((res) => {
        const items = Array.isArray(res && res.data && res.data.items) ? res.data.items : []
        const filtered = items.filter((item) => item && item.type === this.state.typeFilter)
        const sorted = filtered.sort((a, b) => {
          const dateA = new Date(a && a.date ? a.date : 0).getTime()
          const dateB = new Date(b && b.date ? b.date : 0).getTime()
          return dateA - dateB
        })
        const total = sorted.reduce((sum, item) => sum + Number(item && item.value ? item.value : 0), 0)
        this.setState({ dataRecords: sorted, total: total, isLoading: false, isDisabled: false })
      })
      .catch((error) => {
        console.log(error.response || error)
        this.setState({ dataRecords: [], total: 0, isLoading: false, isDisabled: false })
      })
  }

  getPersonName = (record) => {
    if (!record || !record.person) return '-'
    if (typeof record.person === 'object') return record.person.name || '-'
    return '-'
  }

  getCategoryLabel = (record) => {
    if (!record || record.type === 'T') return 'Transferência'
    const categories = Array.isArray(record.category) ? record.category : []
    if (categories.length === 0) return '-'
    if (categories.length > 1) return 'Diversas'
    const category = categories[0] && categories[0].category
    if (!category) return '-'
    if (typeof category === 'object') return category.name || '-'
    const found = this.state.dataCategory.find(
      (item) => item && String(item._id) === String(category)
    )
    return found && found.name ? found.name : '-'
  }

  render() {
    return (
      <>
        <Container>
          <Row className="TitleContainer">
            <Col style={{ padding: '10px' }}>
              <h4>
                <MDBIcon icon="file-alt" className="mr-2 ml-4" />
                Relatórios - Por Período
              </h4>
            </Col>
          </Row>
        </Container>

        <Container className="MainContainer" style={{ backgroundColor: 'white', padding: '5px' }}>
          <Row className="mb-3">
            <Col>
              <Card>
                <Card.Body>
                  <Grid container spacing={2} direction="row" justify="flex-start" alignItems="center">
                    <Grid item xs={12} md={4}>
                      <FormControl controlid="dateStart">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-start-report"
                            label="Início"
                            value={this.state.dateIni}
                            onChange={(e) => this.changeDateIni(e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{
                              'aria-label': 'Alterar Data',
                            }}
                            style={{ marginTop: '0px', width: '150px' }}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                      <FormControl controlid="dateEnd" className="ml-3">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            margin="normal"
                            id="date-picker-end-report"
                            label="Fim"
                            value={this.state.dateEnd}
                            onChange={(e) => this.changeDateEnd(e)}
                            format="dd/MM/yyyy"
                            KeyboardButtonProps={{
                              'aria-label': 'Alterar Data',
                            }}
                            style={{ marginTop: '0px', width: '150px' }}
                          />
                        </MuiPickersUtilsProvider>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl className="w-100">
                        <InputLabel id="report-type-filter">Tipo</InputLabel>
                        <Select
                          labelId="report-type-filter"
                          id="report-type-select"
                          value={this.state.typeFilter}
                          onChange={(e) => this.changeTypeFilter(e.target.value)}
                        >
                          <MenuItem value="R">Receitas</MenuItem>
                          <MenuItem value="D">Despesas</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4} className="text-right">
                      <Button
                        icon
                        labelPosition="left"
                        color={!this.state.isLoading ? 'blue' : 'grey'}
                        disabled={this.state.isDisabled}
                        onClick={this.getRecords}
                      >
                        {!this.state.isLoading ? 'Atualizar' : 'Aguarde'}
                        <Icon name="sync" loading={this.state.isLoading} />
                      </Button>
                    </Grid>
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <div className="text-right mb-2">
                    <strong>Total: </strong>
                    <CurrencyFormat
                      value={this.state.total}
                      displayType={'text'}
                      thousandSeparator="."
                      decimalSeparator=","
                      fixedDecimalScale={true}
                      decimalScale={2}
                      prefix="R$ "
                    />
                  </div>
                  <Table fixed compact celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell style={{ width: '130px' }}>Data</Table.HeaderCell>
                        <Table.HeaderCell>Pessoa</Table.HeaderCell>
                        <Table.HeaderCell>Categoria</Table.HeaderCell>
                        <Table.HeaderCell>Histórico</Table.HeaderCell>
                        <Table.HeaderCell className="text-right" style={{ width: '170px' }}>
                          Valor
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {this.state.dataRecords.length > 0 ? (
                        this.state.dataRecords.map((record) => (
                          <Table.Row key={record._id}>
                            <Table.Cell>{moment(record.date).format('DD/MM/YYYY')}</Table.Cell>
                            <Table.Cell>{this.getPersonName(record)}</Table.Cell>
                            <Table.Cell>{this.getCategoryLabel(record)}</Table.Cell>
                            <Table.Cell>{record.history || '-'}</Table.Cell>
                            <Table.Cell className="text-right">
                              <CurrencyFormat
                                value={record.value}
                                displayType={'text'}
                                thousandSeparator="."
                                decimalSeparator=","
                                fixedDecimalScale={true}
                                decimalScale={2}
                                prefix="R$ "
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))
                      ) : (
                        <Table.Row>
                          <Table.Cell colSpan="5" className="text-center">
                            Nenhum registro encontrado para o filtro.
                          </Table.Cell>
                        </Table.Row>
                      )}
                    </Table.Body>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    )
  }
}
